module.exports = __webpack_public_path__ + "static/media/diego2019.49ca491f.jpeg";